// extracted by mini-css-extract-plugin
export default {"link":"xgrLR1","list":"BndXQ1","open":"ZwIcHo","item":"ZHuLOX"};